import * as React from "react";
import { Redirect, Route } from "react-router";
import { observer } from "mobx-react-lite";
import { Routes } from "./routes/routes";
import { authStore } from "./mobx/stores/AuthStore/AuthStore";

interface AuthProps {
  component: React.FC;
}

export const AuthorizationRoute = observer(({ component: Component, ...rest }: AuthProps) => {
  const { isLogged } = authStore;

  function renderRoute(props: any): React.ReactNode {
    return isLogged ? (
      <Component {...props} />
    ) : (
      <Redirect
        to={{
          pathname: `/${Routes.login}`,
          state: {
            from: props.location,
          },
        }}
      />
    );
  }

  return <Route {...rest} render={renderRoute} />;
});
